import { useEffect, useRef } from 'react';

export function useScrollSyncedVideo() {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    let frame = 0;

    const syncVideo = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const duration = Number.isFinite(video.duration) && video.duration > 0 ? video.duration : 8;
        const maxScroll = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
        const progress = Math.min(Math.max(window.scrollY / maxScroll, 0), 1);
        video.currentTime = progress * duration;
      });
    };

    const prepare = () => {
      video.pause();
      syncVideo();
    };

    video.addEventListener('loadedmetadata', prepare);
    window.addEventListener('scroll', syncVideo, { passive: true });
    window.addEventListener('resize', syncVideo);

    return () => {
      cancelAnimationFrame(frame);
      video.removeEventListener('loadedmetadata', prepare);
      window.removeEventListener('scroll', syncVideo);
      window.removeEventListener('resize', syncVideo);
    };
  }, []);

  return videoRef;
}
